var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["customElement"]: () => __WEBPACK_EXTERNAL_MODULE_lit_decorators_js_226d44c5__.customElement, ["property"]: () => __WEBPACK_EXTERNAL_MODULE_lit_decorators_js_226d44c5__.property });